import React from 'react';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import { ReactSVG } from 'react-svg';
import { dataResources } from '../../../../utils/constants';
import styles from './icona.module.scss';
const { basePath } = dataResources;

function Icona(props) {
    const { icona, alt, isBlanc, className, inline, mida, ariaHidden, path, isEsadir } = props;

    const amplada = mida && !isNaN(mida) ? parseInt(mida) : 24;

    const styleIcona = clsx({
        [styles.icona]: true,
        [className]: !__isEmpty(className)
    });

    const pathIcona = isEsadir ? (path && path !== 'noticies' ? `esadir/${path}` : 'esadir') : path;
    const color = isEsadir ? (isBlanc ? 'blanc' : 'vermell') : isBlanc ? 'blanc' : 'negre';
    const src = `${basePath}/_resources/icones/${pathIcona}/${color}/${icona}.svg?v=JIT_ENV_RESOURCES_VERSION`;

    const imageLoader = ({ src }) => {
        return `${src}`;
    };

    if (inline) {
        return (
            <ReactSVG
                data-icon={icona}
                className={styleIcona}
                beforeInjection={(svg) => {
                    svg.setAttribute('width', '100%');
                    svg.setAttribute('height', '100%');
                }}
                src={src}
                wrapper='span'
                aria-label={alt}
                aria-hidden={ariaHidden}
                role='img'
                data-testid={`icona-${icona}`}
            />
        );
    } else {
        return (
            <span className={styleIcona}>
                <Image
                    loader={imageLoader}
                    width={amplada}
                    height={amplada}
                    unoptimized={true}
                    alt={alt}
                    src={src}
                    aria-hidden={ariaHidden}
                    data-testid={`icona-${icona}`}
                />
            </span>
        );
    }
}

Icona.defaultProps = {
    icona: '',
    alt: '',
    isBlanc: false,
    inline: false,
    className: '',
    path: 'noticies',
    isEsadir: false
};

export default React.memo(Icona);
